if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          document.body.classList.remove(this.classes.show);
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }
    
      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();
        this.playPauseButton = null;
        this.playIcon = null;
        this.pauseIcon = null;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
        this.playPauseButton = this.querySelector('.lbcard__play-pause-button');
        if (!this.playPauseButton) return;

        this.playIcon = this.playPauseButton.querySelector('.lbcard__play-icon');
        this.pauseIcon = this.playPauseButton.querySelector('.lbcard__pause-icon');

        this.playPauseButton.addEventListener('click', this.handlePlayPauseClick.bind(this));
        this.playPauseButton.addEventListener('keydown', this.handleKeydown.bind(this));

        if (this.video) {
          this.video.addEventListener('video:play', this.updateButtonState.bind(this, 'playing'));
          this.video.addEventListener('video:pause', this.updateButtonState.bind(this, 'paused'));
          
          if (this.video.hasAttribute('autoplay')) {
            this.classList.add('is-hovering');
          }
        }
      }

      disconnectedCallback() {
        if (this.playPauseButton) {
          this.playPauseButton.removeEventListener('click', this.handlePlayPauseClick.bind(this));
          this.playPauseButton.removeEventListener('keydown', this.handleKeydown.bind(this));
        }
        if (this.video) {
          this.video.removeEventListener('video:play', this.updateButtonState.bind(this, 'playing'));
          this.video.removeEventListener('video:pause', this.updateButtonState.bind(this, 'paused'));
        }
      }

      handlePlayPauseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.togglePlayPause();
      }

      handleKeydown(event) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          this.togglePlayPause();
        }
      }

      async togglePlayPause() {
        if (this.prefersReducedMotion || !this.video) {
          return;
        }

        const currentState = this.playPauseButton.getAttribute('data-state');
        
        if (currentState === 'paused') {
          this.classList.add('is-hovering');
          
          if (!this.video.hasAttribute('loaded')) {
            await this.video.initializePlayer();
          }
          
          const actualVideo = this.video.querySelector('video');
          if (actualVideo) {
            this.video.paused = false;
            const playPromise = actualVideo.play();
            
            if (playPromise !== undefined) {
              playPromise.then(() => {
                this.video.setAttribute('playing', '');
              }).catch(error => {
                console.warn('Video play failed:', error);
                this.classList.remove('is-hovering');
              });
            } else {
              this.video.setAttribute('playing', '');
            }
          }
        } else {
          this.classList.remove('is-hovering');
          
          const actualVideo = this.video.querySelector('video');
          if (actualVideo) {
            this.video.paused = true;
            actualVideo.pause();
            this.video.removeAttribute('playing');
          }
        }
      }

      updateButtonState(state) {
        if (!this.playPauseButton) return;

        this.playPauseButton.setAttribute('data-state', state);

        if (state === 'playing') {
          this.playPauseButton.setAttribute('aria-label', 
            this.playPauseButton.getAttribute('aria-label').replace('play', 'pause').replace('Play', 'Pause') || 'Pause video'
          );
          if (this.playIcon) this.playIcon.hidden = true;
          if (this.pauseIcon) this.pauseIcon.hidden = false;
        } else {
          this.playPauseButton.setAttribute('aria-label', 
            this.playPauseButton.getAttribute('aria-label').replace('pause', 'play').replace('Pause', 'Play') || 'Play video'
          );
          if (this.playIcon) this.playIcon.hidden = false;
          if (this.pauseIcon) this.pauseIcon.hidden = true;
        }
      }
    }
  );
}